var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    { on: { "scroll-bottom": _vm.fetchActivity } },
    [
      _c("template", { slot: "title" }),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "overview-content" },
          [
            _c("activity-forms", {
              attrs: {
                isSetup: _vm.isSetup,
                linkedtype: _vm.linkedtype,
                linkedid: _vm.linkedid
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "typographies-heading-h2 tab-activity-subtitle" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Historique des activités")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("timeline", {
              attrs: {
                linkedtype: _vm.linkedTypeCheckThirdtype,
                linkedid: _vm.linkedid,
                overviewType: _vm.linkedtype,
                useFilters: true
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }